<div class="add-eoi">
    <!--    <div class="title">EOIs</div>-->
    <div (click)="back(false)" fxLayout="row">
        <mat-icon>chevron_left</mat-icon>
        <div class="back">Back</div>
    </div>
    <div class="page">
        <div class="page-title">Express of Interest</div>

        <div class="info" *ngIf="fileName">
            <p>Please download and complete the&nbsp;</p>
            <p class="eoi-form" (click)="openForm()">EOI Form</p>
            <mat-icon style="font-size: 22px;color:#556EE6;cursor: pointer;" (click)="openForm()">launch</mat-icon>
            <p>&nbsp;before start the express of interest. </p>
        </div>

        <div fxLayout="row" style="margin-top: 25px">
            <div style="width: 10%">Primary Buyer</div>
            <div style="width: 90%;padding: 0 5%">
                <mat-grid-list cols="6" rowHeight="37px" gutterSize="15px">
                    <mat-grid-tile colspan="2">
                        <input placeholder="First Name" class="input" id="first"
                               [(ngModel)]="firstName">
                    </mat-grid-tile>
                    <mat-grid-tile colspan="2">
                        <input placeholder="Middle Name" class="input" id="middle"
                               [(ngModel)]="middleName">
                    </mat-grid-tile>
                    <mat-grid-tile colspan="2">
                        <input placeholder="Last Name" class="input" id="last"
                               [(ngModel)]="lastName">
                    </mat-grid-tile>
                    <mat-grid-tile colspan="3">
                        <input placeholder="Email" class="input" id="email"
                               [(ngModel)]="email">
                    </mat-grid-tile>
                    <mat-grid-tile colspan="3">
                        <input placeholder="Mobile" class="input" id="mobile"
                               [(ngModel)]="mobile">
                    </mat-grid-tile>
                    <mat-grid-tile colspan="6">
                        <input placeholder="Address Line" class="input" id="address"
                               [(ngModel)]="addressLine">
                    </mat-grid-tile>
                    <mat-grid-tile colspan="2">
                        <input placeholder="State" class="input" id="state"
                               [(ngModel)]="state">
                    </mat-grid-tile>
                    <mat-grid-tile colspan="2">
                        <input placeholder="Country" class="input" id="country"
                               [(ngModel)]="country">
                    </mat-grid-tile>
                    <mat-grid-tile colspan="2">
                        <input placeholder="Postcode" class="input" id="postcode"
                               [(ngModel)]="postcode">
                    </mat-grid-tile>
                </mat-grid-list>
            </div>
        </div>

        <div fxLayout="row" style="margin-top: 50px">
            <div style="width: 10%">Upload EOI Form</div>
            <div style="width: 90%;padding: 0 5%">
                <div class="drag-drop">
                    <ngx-file-drop accept=".pdf"
                                   dropZoneLabel="Drop files here"
                                   [showBrowseBtn]=true
                                   (onFileDrop)="dropped($event)"
                                   (onFileOver)="fileOver($event)"
                                   (onFileLeave)="fileLeave($event)">
                        <ng-template ngx-file-drop-content-tmp let-openFileSelector="openFileSelector">
                            <div class="upload-grid" fxLayout="row" (click)="openFileSelector()">
                                <mat-icon style="font-size: 40px">cloud_upload</mat-icon>
                                <div style="margin-left: 25px;">
                                    <div class="txt">Click here or drag your document to upload</div>
                                    <div class="text">Maximum file size is 10 MB Maximum number of files is 3</div>
                                </div>
                            </div>
                        </ng-template>
                    </ngx-file-drop>
                    <div *ngIf="invalidFileType" style="margin-top: 4px; font-size: 14px; color: #dc3545">
                        {{lang === 'en' ? 'The file should be less than 40M and maximum 3 files' : '文件大小不能超过40M且最多3个文件'}}
                    </div>
                    <div *ngIf="isRequired" style="margin-top: 4px; font-size: 14px; color: #dc3545">
                        {{lang === 'en' ? 'This is required' : '此项为必填项'}}
                    </div>
                    <!--                    <div *ngIf="contractFiles && contractFiles.length > 0" style="margin-top: 0.75rem">-->
                    <!--                        <div *ngFor="let f of contractFiles" class="file">-->
                    <!--                            <div style="cursor: pointer">{{ f.name }}</div>-->
                    <!--                            <mat-icon style="color: #dc3545; margin-left: 100px; cursor: pointer"-->
                    <!--                                      (click)="removeFile(f)">delete-->
                    <!--                            </mat-icon>-->
                    <!--                        </div>-->
                    <!--                    </div>-->
                    <!--                    新样式-->
                    <div class="files_list">
                        <div class="single_file" *ngFor="let file of contractFiles;let i = index">
                            <img src="./assets/images/pdf-file.svg" alt="file" width="45px">
                            <div class="info"
                                 fxLayout="column"
                                 fxLayoutAlign="space-between"
                                 fxLayoutGap="10px">
                                <div fxLayout="row" fxLayoutAlign="space-between">
                                    <h4 class="name">
                                        {{ file?.name }}
                                    </h4>
                                    <div
                                            *ngIf="file.progress === 100"
                                            fxLayout="row"
                                            fxLayoutAlign="center center"
                                            fxLayoutGap="10px"
                                    >
                                        <img
                                                src="./assets/images/deleteFile.svg"
                                                width="13px"
                                                height="13px"
                                                alt="file"
                                                (click)="removeFile(file)"
                                        />
                                    </div>
                                </div>
                                <p class="size" *ngIf="file.progress === 100">
                                    {{ currentTime | date: 'HH:mm:ss yyyy-MM-dd' }}
                                </p>
                                <app-progress
                                        *ngIf="file.progress !== 100"
                                        [progress]="file?.progress"
                                        (cancelUpload)="removeFile(file)"
                                ></app-progress>
                            </div>
                        </div>
                    </div>
                    <!--                    新样式-->
                </div>
            </div>
        </div>

        <div fxLayout="row" style="margin-top: 50px">
            <div style="width: 10%">Payment Reciept</div>
            <div style="width: 90%;padding: 0 5%">
                <div class="drag-drop">
                    <ngx-file-drop accept=".pdf, .png, .jpg, .jpeg"
                                   dropZoneLabel="Drop files here"
                                   [showBrowseBtn]=true
                                   (onFileDrop)="droppedReciept($event)"
                                   (onFileOver)="fileOverReciept($event)"
                                   (onFileLeave)="fileLeaveReciept($event)">
                        <ng-template ngx-file-drop-content-tmp let-openFileSelectorReciept="openFileSelector">
                            <div class="upload-grid" fxLayout="row" (click)="openFileSelectorReciept()">
                                <mat-icon style="font-size: 40px">cloud_upload</mat-icon>
                                <div style="margin-left: 25px;">
                                    <div class="txt">Click here or drag your document to upload</div>
                                    <div class="text">Maximum file size is 10 MB Maximum number of files is 3</div>
                                </div>
                            </div>
                        </ng-template>
                    </ngx-file-drop>
                    <div *ngIf="invalidFileRecieptType" style="margin-top: 4px; font-size: 14px; color: #dc3545">
                        {{lang === 'en' ? 'The file should be less than 40M and maximum 3 files' : '文件大小不能超过40M且最多3个文件'}}
                    </div>
                    <!--                    <div *ngIf="contractRecieptFiles && contractRecieptFiles.length > 0" style="margin-top: 0.75rem">-->
                    <!--                        <div *ngFor="let f of contractRecieptFiles" class="file">-->
                    <!--                            <div style="cursor: pointer">{{ f.name }}</div>-->
                    <!--                            <mat-icon style="color: #dc3545; margin-left: 100px; cursor: pointer"-->
                    <!--                                      (click)="removeRecieptFile(f)">delete-->
                    <!--                            </mat-icon>-->
                    <!--                        </div>-->
                    <!--                    </div>-->
                    <div class="files_list">
                        <div class="single_file" *ngFor="let file of contractRecieptFiles;let i = index">
                            <img src="./assets/images/pdf-file.svg" alt="file" width="45px">
                            <div class="info"
                                 fxLayout="column"
                                 fxLayoutAlign="space-between"
                                 fxLayoutGap="10px">
                                <div fxLayout="row" fxLayoutAlign="space-between">
                                    <h4 class="name">
                                        {{ file?.name }}
                                    </h4>
                                    <div
                                            *ngIf="file.progress === 100"
                                            fxLayout="row"
                                            fxLayoutAlign="center center"
                                            fxLayoutGap="10px"
                                    >
                                        <img
                                                src="./assets/images/deleteFile.svg"
                                                width="13px"
                                                height="13px"
                                                alt="file"
                                                (click)="removeRecieptFile(file)"
                                        />
                                    </div>
                                </div>
                                <p class="size" *ngIf="file.progress === 100">
                                    {{ currentTime | date: 'HH:mm:ss yyyy-MM-dd' }}
                                </p>
                                <app-progress
                                        *ngIf="file.progress !== 100"
                                        [progress]="file?.progress"
                                        (cancelUpload)="removeRecieptFile(file)"
                                ></app-progress>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div style="display: flex;justify-content: end;margin: 24px 33px 76px 0">
        <!--        <button mat-stroked-button-->
        <!--                style="margin-right: 20px;color: #556EE6;border-color: #556EE6">{{ "upload.save" | translate }}</button>-->
        <button mat-flat-button style="margin-right: 20px;background: rgba(53, 41, 66, 0.1);color: #352942"
                (click)="back(false)">Back
        </button>
        <button mat-flat-button style="background: #352942;color: #fff"
                (click)="submit()">Create and approve
        </button>
    </div>
</div>
